const AI = Vue.extend({
  template: /* html */ `
    <div>

        <div v-if="false"><!-- The main chat card --></div>
        <transition name="aichatcardtransition">
            <div
                v-if="isChatOpen"
                id="ai-chat-card"
                class="card rounded-lg shadow position-fixed"
            >
                <div class="
                    card-body
                    d-flex
                    flex-column
                    justify-content-between
                    overflow-auto
                    p-0
                    position-relative;
                ">

                    <div v-if="false"><!-- Close button --></div>
                    <button
                        id="ai-chat-closer"
                        class="btn p-0 position-absolute"
                        type="button"
                        aria-label="Close"
                        v-on:click="toggleChat"
                    >
                        <i class="fal fa-times"></i>
                    </button>

                    <div v-if="false"><!-- Top of the chat card --></div>
                    <div
                        id="ai-card-scroll-zone"
                        class="px-4 pt-4 mb-4 overflow-auto"
                    >

                        <div>
                            <h2
                                id="ai-chat-card-title"
                                class="font-weight-bold d-block"
                            >
                                <img
                                    src="/assets/images/components/ai-chat/stars-purple.svg"
                                    width="16"
                                    height="16"
                                    alt=""
                                />
                                Support Database Search
                                <img
                                    src="/assets/images/components/ai-chat/beta-solid.svg"
                                    width="24"
                                    height="20"
                                    alt="beta"
                                />
                            </h2>
                            <p>
                                Solve issues faster with 20i’s
                                <strong>AI-powered</strong>
                                Support Database
                            </p>
                        </div>

                        <div
                            class="card ai-chat-inner-card rounded-lg mb-3"
                        >
                            <div class="card-body">
                                <h3 class="ai-chat-inner-card-title font-weight-bold mb-3">
                                    Get better answers <em>faster</em>
                                </h3>
                                <button
                                    type="button"
                                    class="btn rounded-pill border text-center px-3 py-1 w-100 mb-2"
                                    style="white-space: normal !important;"
                                    v-on:click="autoSendQuestion('How do I add an SPF record to my domain?')"
                                >
                                    How do I add an SPF record to my domain?
                                </button>
                                <button
                                    type="button"
                                    class="btn rounded-pill border text-center px-3 py-1 w-100 mb-2"
                                    style="white-space: normal !important;"
                                    v-on:click="autoSendQuestion('What Cloud Server regions are available?')"
                                >
                                    What Cloud Server regions are available?
                                </button>
                                <button
                                    type="button"
                                    class="btn rounded-pill border text-center px-3 py-1 w-100"
                                    style="white-space: normal !important;"
                                    v-on:click="autoSendQuestion('How do I add credit to my account?')"
                                >
                                    How do I add credit to my account?
                                </button>
                            </div>
                        </div>

                        <div v-if="false"><!-- Chat messages --></div>
                        <transition-group
                            name="aichatmsgtransition"
                            tag="div"
                            class="d-flex flex-column pb-4"
                            style="gap: 1rem;"
                        >
                            <p
                                v-if="chatCleared"
                                class="text-center text-muted small"
                                v-bind:key="-2"
                            >
                                Search cleared
                            </p>

                            <div
                                v-for="msg in qaData"
                                v-bind:key="msg.id"
                                class="ai-chat-msg rounded-lg px-3 py-2 position-relative"
                                v-bind:class="msg.type === 'user' ? 'ai-chat-msg--user' : 'ai-chat-msg--ai'"
                            >
                                <span v-html="msg.type == 'ai' ? parseText(msg.text) : msg.text"></span>
                                <div
                                  v-if="msg.sources && msg.sources.length > 0"
                                  class="pt-2 mt-3"
                                  style="
                                    font-size: 0.75rem;
                                    border-top: 1px solid #ddd;
                                  "
                                >
                                  <b>Sources</b>
                                  <ol class="mb-0" style="padding-left: 13px;">
                                    <li
                                      v-for="source in msg.sources"
                                      class="pt-1"
                                    >
                                      <a v-bind:href="'https://docs.20i.com' + source.url">{{ source.title }}</a>
                                    </li>
                                  </ol>
                                </div>
                                <div
                                    v-if="msg.type === 'ai' && !msg.error"
                                    class="position-absolute"
                                    style="right: 1rem; bottom: -1.2rem;"
                                >
                                    <button
                                        v-bind:id="'ai-chat-thumb-button-like-' + msg.id"
                                        class="btn btn-sm px-3 py-1 ai-chat-thumb-button"
                                        v-bind:class="msg.like === 'like' ? 'bg-success text-white' : 'bg-gray'"
                                        v-on:click="likeResponse(msg.id)"
                                    >
                                        <i
                                            class="fas fa-thumbs-up"
                                        ></i>
                                    </button>
                                    <button
                                        v-bind:id="'ai-chat-thumb-button-dislike' + msg.id"
                                        class="btn btn-sm px-3 py-1 ai-chat-thumb-button"
                                        v-bind:class="msg.like === 'dislike' ? 'bg-danger text-white' : 'bg-gray'"
                                        v-on:click="dislikeResponse(msg.id)"
                                    >
                                        <i
                                            class="fas fa-thumbs-down"
                                        ></i>
                                    </button>
                                </div>
                            </div>

                            <p
                                v-if="somethingWrong"
                                class="text-center text-muted small"
                                v-bind:key="-3"
                            >
                                OpenAI Network Interruption. For more help see
                                our
                                <a href="/support-database">Support&nbsp;Database</a>
                                or
                                <a href="/messages">contact&nbsp;us</a>.
                            </p>
                        </transition-group>

                    </div>

                    <div v-if="false"><!-- AI is thinking... --></div>
                    <div
                        v-if="working"
                        id="ai-chat-working"
                        class="position-absolute"
                    >
                        <div
                            class="d-inline-block rounded-circle ai-chat-working-dot"
                            id="ai-chat-working-dot1"
                        >&nbsp;</div>
                        <div
                            class="d-inline-block rounded-circle ai-chat-working-dot"
                            id="ai-chat-working-dot2"
                        >&nbsp;</div>
                        <div
                            class="d-inline-block rounded-circle ai-chat-working-dot"
                            id="ai-chat-working-dot3"
                        >&nbsp;</div>
                    </div>

                    <div v-if="false"><!-- Bottom of the chat card, chat controls --></div>
                    <div
                        class="
                            d-flex
                            align-items-center
                            justify-content-between
                            px-4
                            pb-4
                        "
                        style="gap: 1rem;"
                    >
                        <div>
                            <button
                                id="ai-chat-clear-button"
                                class="rounded-circle p-0 border-0 position-relative"
                                v-on:click="clearChat"
                            >
                                <img
                                    src="/assets/images/components/ai-chat/broom.svg"
                                    width="24"
                                    height="24"
                                    alt="Clear search"
                                />
                            </button>
                        </div>
                        <div class="w-100">
                            <div
                                id="ai-chat-input-group"
                                class="input-group"
                                v-bind:class="inputDisabled ? 'ai-chat-input-group--disabled' : null"
                            >
                                <input
                                    id="ai-chat-input"
                                    type="text"
                                    class="form-control border-right-0"
                                    placeholder="Search support database…"
                                    v-model="questionInput"
                                    v-on:keyup.enter="sendQuestion()"
                                />
                                <div class="input-group-append">
                                    <button
                                        id="ai-chat-send-button"
                                        class="
                                            btn
                                            btn-outline-secondary
                                            bg-transparent
                                            rounded-right
                                            px-3
                                            border-left-0
                                        "
                                        type="button"
                                        v-on:click="sendQuestion"
                                    >
                                        <i
                                            class="fas fa-paper-plane"
                                        ></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </transition>

        <div v-if="false"><!-- The floating button to open the chat --></div>
        <button
            id="ai-chat-button"
            class="
                text-white
                rounded-pill
                border-0
                shadow
                d-flex
                align-items-center
                justify-content-start
                pl-3
                position-fixed
                overflow-hidden
            "
            v-on:click="toggleChat"
        >
            <img
                src="/assets/images/components/ai-chat/stars.svg"
                width="32"
                height="32"
                alt=""
            />
            <p id="ai-chat-button-text" class="font-weight-bold text-left m-0 position-absolute">
                Solve issues faster with 20i’s AI-powered Support Database
            </p>
        </button>

    </div>
    `,

  props: {
    aiPrompt: {
      type: Object,
      required: false,
      default() {
        return {
          text: "",
          type: "",
        };
      },
    },
  },

  watch: {
    aiPrompt(n, o) {
      if (n && o && n.text != o.text) {
        switch (n.type) {
          case "qa":
            this.askQuestion(n.text);
            break;
          default:
            console.log(`Unknown type ${n.text}`);
        }
      }
    },
    qaData() {
      this.scrollBottom();
      localStorage.setItem("aiChatSession", JSON.stringify(this.qaData));
      localStorage.setItem("aiChatUpdated", Date.now().toString());
    },
  },

  data() {
    return {
      deepLinks: {
        "Order Cloud Server": "/services/build-server",
        "Cloud Server": "/services/cloud-hosting",
        "Create Hosting Package": "/reseller/add-hosting",
        "Domains": "/services/domains",
        "Email Marketing": "/reseller/send-mass-email",
        "Hosting Package Types": "/reseller/package-types",
        "HostShop": "/reseller/hostshop",
        "Mailbox Usage": "/reports/email/usage",
        "Bandwidth Report": "/reports/web/bandwidth",
        "Disk Usage": "/reports/web/disk",
        "MySQL Database Report": "/reports/web/mysql",
        "Malware Report": "/services/malware-report",
        "Package Types Breakdown": "/reports/hosting/package-types",
        "Managed Hosting": "/services/hosting",
        "Managed Cloud Hosting": "/services/cloud-hosting?tab=packages",
        "Manage Virtual Nameservers": "/reseller/manage-virtual-nameservers",
        "Migrations": "/migrations",
        "Platform Transfer": "/migrations/platform-transfer",
        "Start a New Migration": "/migrations/start-migration",
        "Order VPS": "/services/order-vps",
        "Order SSL": "/services/order-ssl",
        "Product Catalogue": "/reseller/hostshop/product-catalogue",
        "Search for Domain Names": "/domain-search",
        "StackCP Notifications": "/reseller/message-centre",
        "StackCP Ticket System": "/reseller/stack-ticket-list",
        "StackCP Users": "/reseller/stack-users",
        "Timeline Backups": "/services/timeline-backups",
        "Transfer Domain Names": "/services/bulk-transfer",
        "WordPress Manager": "/services/wordpress",
        "WHMCS": "/whmcs",
      },
      chatElement: null,
      isChatOpen: false,
      working: false,
      questionInput: "",
      qaData: [],
      messageWriteTicker: null,
      followingUpQuestions: null,
      chatCleared: false,
      somethingWrong: false,
      inputDisabled: false,
      messageId: 0,
      parseText(msg) {
        if (!msg) {
          return "";
        }
        let parts = msg.split("```");
        if (
          parts.length == 3
        ) {
          if (parts[1].match("^php")) {
            parts[1] = "<?" + parts[1];
          }
          parts[1] = parts[1].replace(/</g, "&lt;")
          parts[1] = parts[1].replace(/>/g, "&gt;")
          msg = parts[0] + `<pre class="prettyprint"><code>${parts[1]}</code></pre>` + parts[2];
        }

        for (const text of Object.keys(this.deepLinks)) {
          let url = this.deepLinks[text];
          let link = `<a href="${url}">${text}</a>`;
          let regex = new RegExp(text, "gi");
          msg = msg.replace(regex, link);
        }

        return msg
      }
    };
  },

  methods: {
    getNewMessageId() {
      return this.messageId++;
    },
    getMessageWithId(id) {
      // handle appropriately if no message is found
      return this.qaData.find((msg) => msg.id === id);
    },
    askQuestion(question) {
      if (this.somethingWrong == true) {
        this.somethingWrong = false;
      }
      this.working = true;
      $.ajax({
        url: `/ai/qa`,
        method: "POST",
        data: {
          text: question,
        },
      })
        .then((res) => {
          if (res && res.errors) {
            // Dont push this because its an error response.
            // possibly due to validation.
            // FIXME in the future we may want to display it.
            this.qaData.push({
              id: this.getNewMessageId(),
              type: "ai",
              text: res.errors[0].message,
              error: true,
              logId: 0,
              sources: []
            });
          } else if (res) {
            this.qaData.push({
              id: this.getNewMessageId(),
              error: false,
              type: "ai",
              text: res.response,
              like: "unsure",
              logId: res.logId,
              sources: res.sources
            });
          }
          this.scrollBottom();
        })
        .fail((f) => {
          this.somethingWrong = true;
          this.scrollBottom();
          console.log(f);
        })
        .always(() => {
          this.working = false;
          this.inputDisabled = false;
          document.getElementById("ai-chat-input").focus();
          console.log(this.qaData);
        });
    },
    followUP(question) {
      this.questionInput = question;
      this.sendQuestion();
    },
    scrollBottom() {
      setTimeout(() => {
        // Get the chat element for scroll
        if (!this.chatElement) {
          this.chatElement = document.getElementById("ai-card-scroll-zone");
        }

        if (this.chatElement) {
          // Always scroll to ensure we keep up with new text
          this.chatElement.scrollTop = this.chatElement.scrollHeight;
          PR.prettyPrint();
        }
      }, 300);
    },
    sendQuestion() {
      this.inputDisabled = true;
      document.getElementById("ai-chat-input").blur();
      this.qaData.push({ id: this.getNewMessageId(), type: "user", text: this.questionInput });
      if (this.chatCleared == true) {
        this.chatCleared = false;
      }
      this.scrollBottom();
      setTimeout(() => {
        this.askQuestion(this.questionInput);
        this.questionInput = "";
      }, 1000);
    },
    autoSendQuestion(q) {
      this.inputDisabled = true;
      document.getElementById("ai-chat-input").blur();
      this.qaData.push({ id: this.getNewMessageId(), type: "user", text: q });
      if (this.chatCleared == true) {
        this.chatCleared = false;
      }
      this.scrollBottom();
      setTimeout(() => {
        this.askQuestion(q);
        this.questionInput = "";
      }, 1000);
    },
    toggleChat() {
      this.isChatOpen = !this.isChatOpen;
      if (this.isChatOpen) {
        this.chatElement = null;
        this.scrollBottom();
      }
    },
    clearChat() {
      if (this.qaData.length) {
        this.qaData = [];
        this.messageId = 0;
        this.chatCleared = true;
        this.somethingWrong = false;
      }
    },
    likeResponse(id) {
      if (this.getMessageWithId(id).like != "unsure") {
        return;
      }

      let question = this.getMessageWithId(id - 1);
      if (question.type == "user") {
        this.getMessageWithId(id).like = "like";
        $.ajax({
          url: `/ai/qa/rate`,
          method: "POST",
          data: {
            question: question.text,
            like: true,
            logId: this.getMessageWithId(id).logId,
          },
        });
      }
    },
    dislikeResponse(id) {
      if (this.getMessageWithId(id).like != "unsure") {
        return;
      }

      let question = this.getMessageWithId(id - 1);
      if (question.type == "user") {
        this.getMessageWithId(id).like = "dislike";
        $.ajax({
          url: `/ai/qa/rate`,
          method: "POST",
          data: {
            question: question.text,
            like: false,
            logId: this.getMessageWithId(id).logId,
          },
        });
      }
    },
    restoreSession() {
      // If the AI chat was updated in the past 24 hours, restore.
      // Otherwise, destroy.
      let updated;
      if (localStorage.getItem("aiChatUpdated")) {
        updated = parseInt(localStorage.getItem("aiChatUpdated"));
      }
      const now = Date.now();
      if (updated && now - updated < 86400000) {
        this.qaData = JSON.parse(localStorage.getItem("aiChatSession"));
        // set this.messageId to the max message id now loaded
        // if any of the messages don't have a id, we can't safely restore the session
        // so we'll just start fresh
        if (this.qaData.some((msg) => !msg.id)) {
          this.qaData = [];
          this.messageId = 0;
        } else {
          this.messageId = Math.max(...this.qaData.map((msg) => msg.id)) + 1;
        }
      } else {
        localStorage.removeItem("aiChatSession");
        localStorage.removeItem("aiChatUpdated");
      }
      // console.log('aaa1' + updated);
      // console.log('aaa2' + now);
    },
  },

  mounted() {
    this.restoreSession();
  },
});
